import React, { forwardRef, type ForwardedRef } from 'react';
import { styled } from '@compiled/react';
import { token } from '@atlaskit/tokens';
import { AiIcon } from '@atlassian/jira-atlassian-intelligence';
import { AI_BRANDNAME } from '@atlassian/jira-atlassian-intelligence/src/common/constants';
import { fontSize } from '@atlassian/jira-common-styles/src';
import { useIntl } from '@atlassian/jira-intl';
import { AiEnabledMinimized } from '@atlassian/jira-minimizable-modal/src/ui/modal-container';
import messages from '../../../../common/ui/ai-enabled/ai-enabled-title/messages';
import type { MinimizableAiEnabledMinimizedProps } from './types';

export const MinimizableAiEnabledMinimized = forwardRef<
	HTMLElement,
	MinimizableAiEnabledMinimizedProps
>((props: MinimizableAiEnabledMinimizedProps, ref: ForwardedRef<HTMLElement>) => {
	const { formatMessage } = useIntl();

	return (
		// @ts-expect-error - TS2322 - Property 'ref' does not exist on type 'IntrinsicAttributes & MinimizedContainerProps'.
		<AiEnabledMinimized {...props} ref={ref}>
			<TitleContainer>
				<IconContainer data-testid="issue-create.ui.modal.modal-wrapper.minimizable-ai-enabled-minimized.issue-type-icon">
					<AiIcon size="medium" label={AI_BRANDNAME} />
				</IconContainer>
				{formatMessage(messages.aiEnabledMiniTitle)}
			</TitleContainer>
		</AiEnabledMinimized>
	);
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const IconContainer = styled.span({
	marginRight: token('space.100', '12px'),
	display: 'inline-flex',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const TitleContainer = styled.span({
	display: 'flex',
	alignItems: 'center',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	fontSize: `${fontSize * 0.95}px`,
});
